import React from "react";

function EventTitle() {
  return (
    <div>
      <h1>Organizing meals made swift</h1>
      <p>Let's help you quickly create your next corporate hangout</p>
    </div>
  );
}

export default EventTitle;
